import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'horizontal-menu',
  name: '横向菜单',
  icon: '横',
  group: '导航组件',
  description: '横向滚动展示导航入口',
  defaultProps: {
    items: [],
    activeIndex: 0
  }
}
